class TextHighlight {
  constructor(section) {
    this.section = section;
    this.scrollElement = section.querySelector('[data-scroll-element]');
    this.words = section.querySelectorAll('.text-highlight__word');
    this.totalWords = this.words.length;
    
    this.scrollProgress = 0;
    this.highlightedWords = 0;
    this.savedPosition = 0;
    this.isActive = false;
    
    this.throttleTimeout = null;
    
    this.init();
  }
  
  init() {
    if (!this.scrollElement || this.totalWords === 0) return;
    
    // Initial check
    this.onScroll();
    
    // Bind scroll event with throttle
    window.addEventListener('scroll', () => this.throttledScroll(), { passive: true });
    
    // Also check on resize
    window.addEventListener('resize', () => this.throttledScroll(), { passive: true });
  }
  
  throttledScroll() {
    if (this.throttleTimeout) return;
    
    this.throttleTimeout = setTimeout(() => {
      this.onScroll();
      this.throttleTimeout = null;
    }, 50);
  }
  
  onScroll() {
    const windowHeight = window.innerHeight;
    const windowScrolled = window.pageYOffset || document.documentElement.scrollTop;
    const rect = this.scrollElement.getBoundingClientRect();
    const elementHeight = rect.height;
    
    // Trigger as soon as element starts entering viewport (bottom edge touches viewport top)
    if (rect.top < windowHeight && rect.bottom > 0) {
      // Set initial position on first trigger
      if (this.savedPosition === 0) {
        this.savedPosition = windowScrolled - (windowHeight - rect.top);
        this.isActive = true;
      }
      
      // Calculate scroll progress through element
      const scrolledPast = windowScrolled - this.savedPosition;
      
      // Require scrolling 1.5x the element height to reveal all words (much faster)
      const extendedHeight = elementHeight * 1.5;
      const progress = Math.min(Math.max(scrolledPast / extendedHeight, 0), 1);
      
      // Map progress to word count
      const targetWords = Math.floor(progress * this.totalWords);
      
      // Only update if changed
      if (targetWords !== this.highlightedWords) {
        this.highlightedWords = targetWords;
        this.updateWords();
      }
    } else if (rect.top > windowHeight) {
      // Reset if scrolled back up past the section
      if (this.isActive) {
        this.reset();
      }
    }
  }
  
  updateWords() {
    this.words.forEach((word, index) => {
      if (index < this.highlightedWords) {
        word.classList.add('text-highlight__word--active');
      } else {
        word.classList.remove('text-highlight__word--active');
      }
    });
  }
  
  reset() {
    this.savedPosition = 0;
    this.highlightedWords = 0;
    this.isActive = false;
    this.words.forEach(word => {
      word.classList.remove('text-highlight__word--active');
    });
  }
  
  destroy() {
    window.removeEventListener('scroll', () => this.throttledScroll());
    window.removeEventListener('resize', () => this.throttledScroll());
    if (this.throttleTimeout) {
      clearTimeout(this.throttleTimeout);
    }
  }
}

// Initialize all text highlight sections
function initTextHighlightSections() {
  const sections = document.querySelectorAll('.text-highlight');
  const instances = [];
  
  sections.forEach(section => {
    instances.push(new TextHighlight(section));
  });
  
  return instances;
}

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTextHighlightSections);
} else {
  initTextHighlightSections();
}

// Shopify section events (for theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('.text-highlight');
    if (section) {
      new TextHighlight(section);
    }
  });
}

// Export for manual initialization if needed
window.TextHighlight = TextHighlight;
window.initTextHighlightSections = initTextHighlightSections;